import React, { FC } from "react";
import { ItemListProps } from "./Settings.model";
import {
  IonPage,
  IonItem,
  IonCard,
  IonLabel,
  IonIcon,
  IonContent,
  IonText,
  IonCol,
  IonRow,
} from "@ionic/react";
import Profile from "./Profile";
import Upload from "./Upload";
import { PageProps } from "../Page.model";
import ArrowIcon from '../../assets/arrow-right-settings.svg'
import ProfileActiveIcon from '../../assets/profile-active.svg'
import ProfileIcon from '../../assets/profile.svg'
import UploadIcon from '../../assets/upload.svg'
import PaymentActiveIcon from '../../assets/Menu/payment-active.svg'
import PaymentIcon from '../../assets/Menu/payment.svg'
import './Settings.css'
import cn from "classnames";
import { useRecoilValue, useSetRecoilState } from "recoil";
import {
  showSettingsPayment,
  showSettingsProfile,
  showSettingsUpload,
} from "../../atoms";
import CreditCardForm from "../../components/CreditCardForm";

const Settings: FC<PageProps> = ({ show }) => {
  const showProfile = useRecoilValue(showSettingsProfile)
  const showPayment = useRecoilValue(showSettingsPayment)
  const showUpload = useRecoilValue(showSettingsUpload)
  const setProfile = useSetRecoilState(showSettingsProfile)
  const setPayment = useSetRecoilState(showSettingsPayment)
  const setUpload = useSetRecoilState(showSettingsUpload)

  const itemList: ItemListProps[] = [
    {
      title: 'Profile',
      icon: ProfileIcon,
      iconActive: ProfileActiveIcon,
      path: showProfile,
      activeTab: () => tab(setProfile, setPayment, setUpload)
    },
    {
      title: 'Payment Details',
      icon: PaymentIcon,
      iconActive: PaymentActiveIcon,
      path: showPayment,
      activeTab: () => tab(setPayment, setProfile, setUpload)
    },
    {
      title: 'Upload Bills',
      icon: UploadIcon,
      iconActive: UploadIcon,
      path: showUpload,
      activeTab: () => tab(setUpload, setProfile, setPayment)
    },
  ]

  const tab = (active, passiveFirst, passiveSecond) => {
    active(true)
    passiveFirst(false)
    passiveSecond(false)
  }

  return show && (
    <IonPage className="settings-wrapper">
      <IonItem className="no-border settings-header">
        <IonText className="settings-header-text">
          Settings
        </IonText>
      </IonItem>
      <IonCard className="settings-wrapper-card">
        {itemList.map((item: ItemListProps) => (
          <IonItem
            button
            detail
            detailIcon={ArrowIcon}
            className="settings-item no-p-start"
            key={item.title}
            onClick={item.activeTab}
          >
            <IonIcon src={item.path ? item.iconActive : item.icon} className="settings-icon" />
            <IonLabel className={cn('settings-item-label', { 'active': item.path })}>
              {item.title}
            </IonLabel>
          </IonItem>
        ))}
      </IonCard>
      <IonContent className="settings-content">
        {showProfile && <Profile />}
        {showPayment && <CreditCardForm />}
        {showUpload && <Upload />}
      </IonContent>
    </IonPage>
  )
}

export default Settings
